import { useContext } from 'react';
import { Context, ContextValue } from './context';

export const useTicketing = (): ContextValue => useContext(Context);
